export default class XhqCustomsUnfrozenState {
  constructor(code, englishName, chineseName) {
    this.code = code
    this.chineseName = chineseName
    this.englishName = englishName
  }
}

export const FROZEN = new XhqCustomsUnfrozenState(0, '未解冻', 'Frozen')
export const UN_FROZEN = new XhqCustomsUnfrozenState(1, '已解冻', 'Unfrozen')
export const UN_FROZEN_OFFLINE = new XhqCustomsUnfrozenState(2, '已解冻(线下解冻)', 'unfrozen offline')
